import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import RaisedButton from 'material-ui/RaisedButton';

import { acceptUserClaimsToVessel, rejectUserClaimsToVessel } from 'actions/vessels/claims';

class VesselClaimsItem extends React.Component {
    constructor(props) {
        super(props);

        this.handleAccept = this.handleAccept.bind(this);
        this.handleReject = this.handleReject.bind(this);
    }

    handleAccept(userId, vesselId) {
        this.props.acceptUserClaimsToVessel(userId, vesselId);
    }

    handleReject(userId, vesselId) {
        this.props.rejectUserClaimsToVessel(userId, vesselId);
    }

    render() {
        const { item } = this.props;

        return (
            <div className='item-claim row'>
                <div className='col-xs-3'>
                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>Vessel info {item._id}</    div>
                        <span>Name: </span>{item.name}<br />
                        <span>Capacity: </span>{item.capacity}<br />
                        <span>Built: </span>{item.built}<br />
                        <span>ImoNumber: </span>{item.imoNumber}
                    </div>
                </div>
                <div className='col col-xs-9'>
                    <div className='row'>
                        {
                            item.users.map((user, key) => {
                                return (<div key={key} className='paper-block col-xs-4'>
                                    <div className='name-block absolute small-name'>User info {user._id}</div>
                                    <span>Name: </span>{user.name}<br />
                                    <span>Surname: </span>{user.surname}<br />
                                    <span>email: </span>{user.email}<br />
                                    <span>addedAt: </span>{moment(user.addedAt).format('MM-DD-YYYY')}<br />
                                    <span>Company: </span>{user.company ? user.company.name : ''}<br /><br />
                                    <RaisedButton
                                        onClick={() => { this.handleReject(user._id, item._id); }}
                                        label='reject'
                                        secondary
                                    />
                                    <RaisedButton
                                        onClick={() => { this.handleAccept(user._id, item._id); }}
                                        label='accept'
                                        primary
                                    />
                                </div>);
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, { item }) => {
        return {
            item,
        };
    },
    dispatch => bindActionCreators({
        acceptUserClaimsToVessel,
        rejectUserClaimsToVessel,
    }, dispatch),
)(VesselClaimsItem);



// WEBPACK FOOTER //
// ./app/components/Vessels/Claims/Item.jsx